export default "__VITE_ASSET__JFTyYYmt__$_?component__"